// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"styles_spinnerWrapper__YvdSf","spinner":"styles_spinner__sHARc","spin":"styles_spin__U5Lmf"};